module.exports = __webpack_public_path__ + "static/media/testimonial-michelle-jones.7bee3fcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/testimonial-michelle-jones.jpg
// module id = 402
// module chunks = 0